export default __webpack_public_path__ + "static/media/Vitae_Loader.bf2953af.png";